import { NavLink } from "react-router-dom";
import React from "react";
import { IoIosArrowDown } from "react-icons/io";
import { BsGlobe } from "react-icons/bs";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import LanguageDropdown from "../../../components/languageDropdown/LanguageDropdown";
import MenuHelper from "../../../helpers/MenuHelper";
import ErrorBoundary from "../../../helpers/ExceptionHandler/componentException";

const SideBarMenuDropdown = (props) => {
  const DropdownData = () => {
    return (
      <>
        <a
          className={`dropdown-item fade-in ${props?.openMenu.includes(props?.v.code) ? "active" : ""
            }`}
          onClick={() => {
            props?.pushMenu(props?.v.code);
          }}
        >
          <>
            {props?.v?.code == 'language' ?
              <>
                <BsGlobe />
                {props.t('language')}
              </>
              :
              <>
                <MenuHelper t={props.t} ftpPath={props?.playerMenu?.ftp_path} data={props?.v} className={"sidebar-img"} />
              </>
            }
          </>
          {"  "}
          <IoIosArrowDown className="down-arrow" />
        </a >
        {props?.openMenu.includes(props?.v.code) && (
          <div className="sub-menu">

            {Object.values(props?.menuList).map((data, i) => {
              const isOpenDropMatches = props?.openMenu.includes(props?.v.code);
              const isDrop = isOpenDropMatches && props?.openMenu.includes(props?.v.code) && data.parent_menu_code === props?.v.code && data.status;
              if (isDrop) {
                return (
                  <NavLink
                    to={data.code}
                    onClick={(e) => {
                      e.preventDefault();
                      props?.handleClose(data.code);

                    }}
                    key={i}
                  >
                    <MenuHelper t={props.t} ftpPath={props?.playerMenu?.ftp_path} data={data} className={"sidebar-img"} />
                  </NavLink>
                )
              }
            })}

            {props?.v.code == 'language' && (
              <ErrorBoundary>
                <LanguageDropdown view="mobile" />
              </ErrorBoundary>
            )}
          </div>
        )}
      </>

    )
  }
  return (
    <>
      {(props?.v.location === 'menu' || props?.v.location === 'sub_menu') && (props.desktop ? !props.v.footer_menu : props?.v.code != "help" && props?.v.code != "promotion" && props?.v.code != "home") && props?.v.code != 'live-chat' && props?.v.status && (
        <React.Fragment key={props?.i}>
          {(() => {
            const hasSubmenus = Object.values(props?.menuList).some(submenu => submenu.parent_menu_code === props?.v.code);
            if (props?.v.code === "transactions" && !props?.loggedIn) {
              return null;
            } else if (hasSubmenus || props?.v.location === 'sub_menu' || props?.v.code == 'language' && props?.v.code != 'live-chat') {
              return (
                <>
                  {(!props?.v.parent_menu_code && props?.v.location === 'menu') &&
                    <>
                      {DropdownData()}
                    </>
                  }
                </>
              );
            } else {
              return (
                <NavLink to={props?.customLink} onClick={() => props?.handleClose()}>
                  <MenuHelper t={props.t} ftpPath={props?.playerMenu?.ftp_path} data={props?.v} className={"sidebar-img"} />
                </NavLink>
              );
            }
          })()}
        </React.Fragment >
      )}
    </>
  );
};

SideBarMenuDropdown.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(SideBarMenuDropdown);
